export default "/static/webpack/media/next-arrow-white.3c1d4830.svg";